import { render } from "./DisbursmentTable.vue?vue&type=template&id=3c58d330&scoped=true"
import script from "./DisbursmentTable.vue?vue&type=script&lang=js"
export * from "./DisbursmentTable.vue?vue&type=script&lang=js"

import "./DisbursmentTable.vue?vue&type=style&index=0&id=3c58d330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c58d330"]])

export default __exports__